/** Specifies the stylesheets types */
export enum StylesheetType {
  /** General stylesheet */
  General = "general",
  /** Branding stylesheet */
  Branding = "branding",
  /** Table stylesheet */
  Table = "table",
}
